import {
    FETCH_DRAWS_REQUEST,
    FETCH_DRAWS_SUCCESS,
    FETCH_DRAWS_FAILURE,
    FETCH_DRAW_HISTORY_SUCCESS,
    UPDATE_SCRIPT_STATUS,
    GET_PENDING_DRAWS,
    GET_CURRENT_DRAWS,
    DRAW_ERROR
} from '../actions/drawActions';

const initialState = {
    draws: [],
    pendingDraws: [],
    currentDraws: [],
    drawHistory: {
        draws: [],
        pagination: null
    },
    scriptStatus: {
        isRunning: false,
        activeGames: 0
    },
    loading: false,
    error: null
};

const drawReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_DRAWS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case FETCH_DRAWS_SUCCESS:
            return {
                ...state,
                loading: false,
                draws: action.payload,
                error: null
            };
        case FETCH_DRAWS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        case FETCH_DRAW_HISTORY_SUCCESS:
            return {
                ...state,
                drawHistory: action.payload
            };
        case UPDATE_SCRIPT_STATUS:
            return {
                ...state,
                scriptStatus: action.payload
            };
        case GET_PENDING_DRAWS:
            return { ...state, pendingDraws: action.payload, loading: false };
        case GET_CURRENT_DRAWS:
            return { ...state, currentDraws: action.payload, loading: false };
        default:
            return state;
    }
};

export default drawReducer;